export enum StatusParcelaEnum {
  STATUS_EM_DIA = 'STATUS_EM_DIA',
  STATUS_VENCIDA = 'STATUS_VENCIDA',
  STATUS_ACORDO_RENEGOCIADO = 'STATUS_ACORDO_RENEGOCIADO',
  STATUS_PAGO = 'STATUS_PAGO',
  STATUS_FORA_RANGE_ACORDO = 'STATUS_FORA_RANGE_ACORDO'
}
